module.exports = __webpack_public_path__ + "4214b91f821e22b1fcbad7dc911c84c0.pdf";